export default {
    edit: 'Επεξεργασία',
    location: 'Τοποθεσία + Όροι & Προϋποθέσεις',
    filter: 'Φίλτρο',
};
